import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/shared/api/apiClient';
import { handleRequest } from '@/shared/api/apiWrapper';
import type { CryptoDepositAddressResponse } from '@/shared/types';

const generateCryptoDepositAddress = async (
  networkName: string,
  assetCode: string
): Promise<CryptoDepositAddressResponse> => {
  const request = () =>
    apiClient.get(
      `/operations/crypto/${networkName}/deposit/new?assetCode=${assetCode}`
    );
  const response = await handleRequest(request);

  return response.data;
};

type GenerateCryptoDepositAddressParams = {
  networkName: string;
  assetCode: string;
};

export function useGenerateCryptoDepositAddress() {
  const mutation = useMutation<
    CryptoDepositAddressResponse,
    Error,
    GenerateCryptoDepositAddressParams
  >({
    mutationFn: ({ networkName, assetCode }) =>
      generateCryptoDepositAddress(networkName, assetCode),
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  };
}
